export default "__VITE_ASSET__dd400ac4__"